// extracted by mini-css-extract-plugin
export default {"section":"Services_section__m7DHS","navigation":"Services_navigation__-wcJf","home":"Services_home__OQWc2","list":"Services_list__+2ctm","cars":"Services_cars__WxjKm"};